'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;

	function init() {
		var dateToday = new Date();

		var dateSpring = new Date(dateToday.getFullYear(), 2, 1, 0, 0, 0);
		var dateSummer = new Date(dateToday.getFullYear(), 5, 1, 0, 0, 0);
		var dateAutumn = new Date(dateToday.getFullYear(), 8, 1, 0, 0, 0);
		var dateWinter = new Date(dateToday.getFullYear(), 11, 1, 0, 0, 0);

		context.find('[data-binding="season-toggle"]').on('click', function (e) {
			e.preventDefault();
			var href = $(this).attr('href');
			context.find('[data-binding="season-toggle"]').removeClass('active');
			$(this).addClass('active');
			context.find('[data-binding="season-panel"]').hide();
			context.find(href).show();
		});

		context.find('[data-binding="season-panel"]:not(:first)').hide();
		context.find('[data-binding="season-toggle"]:first').addClass('active');

		if (dateToday >= dateSpring && dateToday < dateSummer) {
			context.find('[href="#Spring"]').click();
		} else if (dateToday >= dateSummer && dateToday < dateAutumn) {
			context.find('[href="#Summer"]').click();
		} else if (dateToday >= dateAutumn && dateToday < dateWinter) {
			context.find('[href="#Autumn"]').click();
		} else {
			context.find('[href="#Winter"]').click();
		}
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/reserve-seasonal-highlights.js
// module id = 501
// module chunks = 0